export const normalizeCodeFieldSelection = (fieldKeys: string[]) => {
  const seen = new Set<string>();

  return fieldKeys.filter((fieldKey) => {
    if (!fieldKey || seen.has(fieldKey)) {
      return false;
    }

    seen.add(fieldKey);
    return true;
  });
};

export const getNextCodeFieldSelection = ({
  currentFieldKeys,
  fieldKey,
  multiSelect,
}: {
  currentFieldKeys: string[];
  fieldKey: string;
  multiSelect: boolean;
}) => {
  const normalizedKeys = normalizeCodeFieldSelection(currentFieldKeys);

  if (!multiSelect) {
    return [fieldKey];
  }

  if (!normalizedKeys.includes(fieldKey)) {
    return [...normalizedKeys, fieldKey];
  }

  const nextKeys = normalizedKeys.filter((key) => key !== fieldKey);

  return nextKeys.length > 0 ? nextKeys : [fieldKey];
};

export const getPrimaryCodeFieldKey = (fieldKeys: string[]) =>
  fieldKeys[fieldKeys.length - 1] ?? null;
